import { ColumnOptions } from '../interfaces';

export abstract class GridActionHandler {

  abstract handleRowClick(params: any, options: ColumnOptions[]): void;
  abstract handleCellClick(params: any, options: ColumnOptions[]): void;

}
